<div [froalaEditor]="options" [froalaModel]="content" (froalaModelChange)="onChange($event)"></div>
